import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getMetaDataAsync } from "./actions";
import { IMetaDataState } from "./slice";

type Reducer = (builder: ActionReducerMapBuilder<IMetaDataState>) => void;

export const getMetaDataReducer: Reducer = (builder) => {
  builder.addCase(getMetaDataAsync.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(getMetaDataAsync.fulfilled, (state, actions) => {
    state.isLoading = false;
    state.data = actions.payload;
  });

  builder.addCase(getMetaDataAsync.rejected, (state) => {
    state.isLoading = false;
    state.data = null;
  });
};
